import React from "react";
import ReactDOM from "react-dom";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./ExternalLinkWarning.css";

/**
 * Redirect warning page shown before leaving the site via an external link.
 * The target URL is passed as the "url" query parameter.
 *
 * Rendered via a portal straight into document.body (same pattern as
 * ReportModal.tsx) instead of inline in the React tree. position: fixed
 * alone wasn't enough to keep the box viewport-centered — portal-ing it
 * out from under any ancestor removes that dependency entirely, no matter
 * which ancestor was the actual cause.
 */
export const ExternalLinkWarning: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  // Decode the target URL from the query string
  const targetUrl = params.get("url") || "";

  const handleContinue = () => {
    if (targetUrl) {
      window.open(targetUrl, "_blank", "noopener,noreferrer");
    }
    navigate(-1);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return ReactDOM.createPortal(
    <div className="elw-overlay">
      <div className="elw-box">
        <h2 className="elw-title">3 Korner 1 Penaltı</h2>
        <p className="elw-body">
          Site dışındaki bu bağlantıya yönlendirilmek istiyor musun?
        </p>
        <a className="elw-url" href={targetUrl} target="_blank" rel="noopener noreferrer">
          {targetUrl}
        </a>
        <div className="elw-buttons">
          <button className="elw-btn elw-btn--back" onClick={handleGoBack}>
            GERİ DÖN
          </button>
          <button className="elw-btn elw-btn--continue" onClick={handleContinue}>
            DEVAM ET
          </button>
        </div>

      </div>
    </div>,
    document.body
  );
};